import { Serializable } from "./Serializable";

export enum ValidationTypeEnum {
    MIN_LENGTH = 'min-length',
    MAX_LENGTH = 'max-length',
    MIN_UPPERCASE = 'min-uppercase',
    MIN_LOWERCASE = 'min-lowercase',
    MIN_SPECIAL_CHAR_FROM = 'min-special-char-from',
    MIN_LETTER = 'min-letter',
    MIN_NUMERIC = 'min-numeric',
    BLACK_LIST_CHAR = 'black-list-char',
    WHITE_LIST_CHAR = 'white-list-char',
    MIN_SPECIAL_CHAR = 'min-special-char',
    MAX_ATTEMPTS = 'max-attempts',
    RESET_IN_MILLIS = 'reset-in-millis',
    NOT_USUABLE_PASSWORDS = 'not-usable-passwords'

    // MAX_UPPERCASE = 'max-uppercase',
    // MAX_LOWERCASE = 'max-lowercase',
    // MAX_SPECIAL_CHAR = 'max-special-char',
    // MAX_NUMERIC = 'max-numeric',
};
export enum ValueTypeEnum {
    DATE = 'date',
    NUMBER = 'integer',
    FLOAT = 'float',
    STRING = 'string'
}

export class ValidationPolicy implements Serializable<ValidationPolicy> {
    validationType: ValidationTypeEnum;
    valueType: ValueTypeEnum;
    value: any;
    valuesFrom: string;

    constructor() {
    }

    // this will be used for casting JSON to object
    deserialize(input) {
        if (input && input.validationType && input.valueType && input.value) {
            this.validationType = input.validationType as ValidationTypeEnum;
            this.valueType = input.valueType as ValueTypeEnum;
            switch (this.valueType) {
                case ValueTypeEnum.DATE:
                    this.value = new Date(input.value);
                    break;
                case ValueTypeEnum.NUMBER:
                    this.value = parseInt(input.value);
                    break;
                case ValueTypeEnum.FLOAT:
                    this.value = parseFloat(input.value);
                    break;
                case ValueTypeEnum.STRING:
                    this.value = input.value.toString();
                    break;
            }
            !!input.valuesFrom && (this.valuesFrom = input.valuesFrom);
            return this;
        } else {
            return null;
        }
    }
}
